import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9986c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Help")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Request a feature, report a bug, or chat with us about anything Monarch-related. ", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Loading checks")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Error loading checks")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Local Data")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Clear all of your locally-saved data, such as your recent node searches and feedback form drafts. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Learn more.")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" If you still need help, or for general inquires, you can ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("email us")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("tweet us")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(". ")

import { onMounted } from "vue";
import { getUptimes } from "@/api/uptime";
import { useQuery } from "@/util/composables";

/** list of status checks to display */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHelp',
  setup(__props) {

const { query, data: uptimes, isLoading, isError } = useQuery(getUptimes, []);

onMounted(query);

/** clear user localstorage data */
function clearData() {
  if (
    window.confirm(
      "Are you sure you want to clear your local data? This cannot be undone."
    )
  ) {
    window.localStorage.clear();
    window.alert(
      "Your local data has been cleared. Restart the app for changes to take effect."
    );
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppTile = _resolveComponent("AppTile")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppGallery = _resolveComponent("AppGallery")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppLink = _resolveComponent("AppLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_component_AppFlex, { gap: "big" }, {
          default: _withCtx(() => [
            _createVNode(_component_AppTile, {
              icon: "comment",
              title: "Feedback Form",
              subtitle: "Right here, no account required, one-way",
              to: "/feedback"
            }),
            _createVNode(_component_AppTile, {
              icon: "comments",
              title: "Help Desk",
              subtitle: "On GitHub, requires account, two-way",
              to: "https://github.com/monarch-initiative/helpdesk"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 0,
              code: "loading"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppGallery, { size: "small" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uptimes), (uptime, index) => {
              return (_openBlock(), _createBlock(_component_AppStatus, {
                key: index,
                class: "status",
                code: uptime.code,
                link: uptime.link
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(uptime.text), 1)
                ]),
                _: 2
              }, 1032, ["code", "link"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          to: "https://stats.uptimerobot.com/XPRo9s4BJ5",
          text: "More Details",
          icon: "arrow-right"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("p", null, [
          _hoisted_7,
          _createVNode(_component_AppLink, { to: "/terms#local-data" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_AppButton, {
          text: "Clear Local Data",
          icon: "floppy-disk",
          onClick: clearData
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_9,
          _createVNode(_component_AppLink, { to: "mailto:info@monarchinitiative.org" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _hoisted_11,
          _createVNode(_component_AppLink, { to: "https://twitter.com/MonarchInit" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _hoisted_13
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})